import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { createRiskManagementNavigation } from './risk-management-navigation';

export const RiskManagementShell = () => {
  const { pathname } = useLocation();
  const [navigation] = useState(createRiskManagementNavigation);
  const outletNavigation = pathname.startsWith('/risk-management/') ? navigation : undefined;

  return <Outlet context={outletNavigation} />;
};
